The status of the position opening.

Defaults to `Active` if no value is provided.

Currently, three codes are defined:

- `Incomplete` indicates the position opening is in draft.
- `Active` indicates the position opening is open.
- `Closed` indicates the position opening has been closed.
